import Apps from '@material-ui/icons/Apps';

import { ThirdPartyAppCreate } from './Create/Create';
import { ThirdPartyAppsShow } from './Show/Show';
import { ThirdPartyAppEdit } from './Edit/Edit';
import { ThirdPartyAppsList } from './List/List';


export {
	ThirdPartyAppsList,
	ThirdPartyAppsShow,
	ThirdPartyAppCreate,
	ThirdPartyAppEdit,
};


export const sharedThirdPartyAppsResource = {
	list: ThirdPartyAppsList,
	edit: ThirdPartyAppEdit,
	create: ThirdPartyAppCreate,
	icon: Apps,
};

export const thirdPartyAppsResource = {
	...sharedThirdPartyAppsResource,
	show: ThirdPartyAppsShow,
};

export const readonlyThirdPartyAppsResource = {
	list: ThirdPartyAppsList,
	show: ThirdPartyAppsShow,
	icon: Apps,
};
